module.exports = __webpack_public_path__ + "img/leyesMunicipal.40e8fb6f.jpg";